import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler = (uischema) => {
  if (uischema.type !== CONTROL_NAME.AUTH_CONTROL) {
    throw new Error('Expected a valid Auth control')
  }

  return {
    type: next.BLOCK_TYPE.AUTH,
    settings: {
      ...upCommonSettings(uischema)
    }
  }
}
